import React from "react";

const NotFound = () => {
  return (
    <div>
      <img
      className="w-100 h-100"
        src="https://miro.medium.com/max/800/1*hFwwQAW45673VGKrMPE2qQ.png"
        alt=""
      />
    </div>
  );
};

export default NotFound;
